/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_LayoutInputs */

const cs_form_layout = /** @type {(inputs: Form_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispozice`)
};

const en_form_layout = /** @type {(inputs: Form_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Form_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_layout = /** @type {((inputs?: Form_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_layout(inputs)
	return cs_form_layout(inputs)
});